

<b class="default-font-size" translate="Request.Actions.AllDocuments"></b>
<ul class="d-none d-lg-block list-group mt-3 mb-4">
  <li class="list-group-item subheader d-block pt-1 pe-0 pb-1 ps-2">
    <div class="row w-100 d-flex p-0 align-items-center">
      <div class="col-5 firstcol text-truncate">
        <span translate="Request.Actions.Person"></span>
      </div>
      <div class="col-6 text-truncate"><span translate="Request.Actions.Action"></span></div>
      <div class="col-1 text-end">

        <div ngbDropdown class="dropdown float-end">
          <button class="btn btn-sm btn-success dropdown-toggle" [disabled]="allowedToAddMoreRequestActions()" type="button"
            id="dropdownMenu" ngbDropdownToggle><span translate="Button.AddActions"></span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownMenu">
            <ng-container *ngFor="let action of allRequestActionsFromSummary()">
              <button [disabled]="isActionDisabled(action)" (click)="openAddActionDialog(action)" class="action"
                ngbDropdownItem translate="Button.{{action}}"></button>
            </ng-container>
          </div>

        </div>

      </div>
    </div>
  </li>
  <li class="list-group-item d-block pt-1 pe-0 pb-1 ps-2 subtable" *ngFor="let person of allDocumentsActions;">
    <app-action-table-document-actions [action]="person"></app-action-table-document-actions>
  </li>
</ul>